import { __read, __values } from "tslib";
export function parseQueryString(querystring) {
  var e_1, _a;

  var query = {};
  querystring = querystring.replace(/^\?/, "");

  if (querystring) {
    try {
      for (var _b = __values(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()) {
        var pair = _c.value;

        var _d = __read(pair.split("="), 2),
            key = _d[0],
            _e = _d[1],
            value = _e === void 0 ? null : _e;

        key = decodeURIComponent(key);

        if (value) {
          value = decodeURIComponent(value);
        }

        if (!(key in query)) {
          query[key] = value;
        } else if (Array.isArray(query[key])) {
          query[key].push(value);
        } else {
          query[key] = [query[key], value];
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  return query;
}